import { apiClient } from './apiClient';
import {
  MonthlyPlan,
  MonthlyPlanOverview,
  MonthlyPlanTemplate,
  CreateMonthlyPlanRequest,
  UpdateMonthlyPlanRequest
} from './types';

export const monthlyPlanService = {
  /**
   * План місяця (null, якщо ще не створено) разом з фактичними рухами коштів за місяць
   */
  async getOverview(year: number, month: number): Promise<MonthlyPlanOverview> {
    return apiClient.get<MonthlyPlanOverview>(`/monthly-plans/${year}/${month}`);
  },

  /**
   * Підказка для створення плану: шаблони витрат, рахунки заощаджень та значення найближчого плану
   */
  async getTemplate(year: number, month: number): Promise<MonthlyPlanTemplate> {
    return apiClient.get<MonthlyPlanTemplate>(`/monthly-plans/${year}/${month}/template`);
  },

  async getById(id: string): Promise<MonthlyPlan> {
    return apiClient.get<MonthlyPlan>(`/monthly-plans/${id}`);
  },

  async create(plan: CreateMonthlyPlanRequest): Promise<MonthlyPlan> {
    return apiClient.post<CreateMonthlyPlanRequest, MonthlyPlan>('/monthly-plans', plan);
  },

  async update(id: string, plan: UpdateMonthlyPlanRequest): Promise<MonthlyPlan> {
    return apiClient.put<UpdateMonthlyPlanRequest, MonthlyPlan>(`/monthly-plans/${id}`, plan);
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/monthly-plans/${id}`);
  }
};
